import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installAxiosInterceptors } from './config/apiClient';
import { installVersionWatcher } from './config/versionWatcher';

installAxiosInterceptors();
// Live refresh: nowe wdrożenia wchodzą automatycznie (auto-reload przy zmianie
// builda), bez utknięcia na starym, scache'owanym SPA.
installVersionWatcher();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
